import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import _ from 'lodash';

interface ReportsOverviewState {
	tabIndex: number;
	reportType: 'all' | string;
	sortBy: 'created' | 'modified' | 'az';
	direction: 'asc' | 'desc';
	viewMode: 'grid' | 'list';
	setTabIndex: (tab: number) => void;
	setReportType: (type: 'all' | string) => void;
	setSortBy: (sortBy: 'created' | 'modified' | 'az') => void;
	setDirection: (direction: 'asc' | 'desc') => void;
	setViewMode: (viewMode: 'grid' | 'list') => void;
	reset: () => void;
	isChanged: (key: keyof ReportsOverviewState) => boolean;
}

export const ReportsOverviewStoreDefaults = {
	tabIndex: 0,
	reportType: 'all',
	sortBy: 'created' as const,
	direction: 'asc' as const,
	viewMode: 'grid' as const,
};

export const useReportsOverviewStore = create<ReportsOverviewState>()(
	persist(
		(set, get) => ({
			...ReportsOverviewStoreDefaults,
			setTabIndex: (tab) => set({ tabIndex: tab }),
			setReportType: (type) => set({ reportType: type }),
			setSortBy: (sortBy) => set({ sortBy }),
			setDirection: (direction) => set({ direction }),
			setViewMode: (viewMode) => set({ viewMode }),
			reset: () => set(_.pick(ReportsOverviewStoreDefaults, ['tabIndex', 'reportType'])),
			isChanged: (key) => get()[key] !== ReportsOverviewStoreDefaults[key],
		}),
		{
			name: 'reports-overview',
			partialize: (state) => ({
				sortBy: state.sortBy,
				direction: state.direction,
				viewMode: state.viewMode,
			}),
		},
	),
);
